export default "__VITE_ASSET__DvNXP1Ng__"